import { createSlice } from '@reduxjs/toolkit';

import { logout } from 'redux/auth/actions';

import { createOAuth, OAuthErrorCodeEnum, OAuthCreateAccountParams, clearOauthData } from './actions';

export interface OAuthState {
    code: OAuthErrorCodeEnum | null;
    oauthErrorUserData: OAuthCreateAccountParams | undefined;
}

const initialState: OAuthState = {
    code: null,
    oauthErrorUserData: undefined,
};

const oauthSlice = createSlice({
    name: 'oauth',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(createOAuth.rejected, (state, { payload }) => {
            if (payload?.error) {
                state.code = payload?.error.code;
            }
            if (payload?.error?.extra) {
                const extra = JSON.parse(payload?.error?.extra as string);
                state.oauthErrorUserData = extra?.oauthData;
            }
        });
        builder.addCase(logout.fulfilled, () => {
            return initialState;
        });
        builder.addCase(clearOauthData, () => {
            return initialState;
        });
    },
});

export default oauthSlice.reducer;
